<ng-container *ngIf="!isHidden && (navigationConfig$ | async) as navigationConfig">
  <ng-container *ngIf="(currentApp$ | async) as currentApp">
    <gen-navigation-app-launcher
        (OnAppLauncherClick)="onAppLauncherClick($event)"
        [applications]="navigationConfig?.navigation?.applications"
        [currentApp]="currentApp">
    </gen-navigation-app-launcher>

    <div *ngIf="currentApp.id=='default'" class="title defaultCursor Spacebox__flat-l Auto_Title_Message">
        {{navigationConfig.dashboard.appName.replace('powered by {appLogoPlaceholder}','')}}
    </div>

    <div *ngIf="currentApp.id!=='default'" class="title defaultCursor Spacebox__flat-l Auto_Title_Message">{{currentApp.headerTitle | stringTranslate}}</div>
  </ng-container>

  <ng-container *ngIf="(navigationItems$ | async) as navigationItems">
    <ng-container *ngFor='let navigationItem of navigationItems|slice:0:2;let first = first;'>
       <gen-navigation-bar-item *ngIf="navigationItem.text !== ''"
                                [item]="navigationItem"
                                (onNavigationClick)="onNavigationClick($event)"
                                [isFirst]="first"
                                [selected]="isItemActive(navigationItem)"
                                [isDropdown]=false>
       </gen-navigation-bar-item>
    </ng-container>

    <ng-container *ngIf="navigationItems?.length > 2 && navigationItems[2].text !== '' ">
      <section (clickOutside)="showMore = false" class="navigation-bar-tab-more">
        <a (click)="showMore = !showMore"  class="title sub-title-next pointer" id="nav_item_more">{{'More' | translate}}
             <span class="fa fa-caret-down navigation-bar-tab-icon"></span>
         </a>
        <div class="navigation-bar-tab-dropdown" [style.display]="showMore ? 'block' : 'none' ">
          <ng-container *ngFor="let navigationItem of navigationItems|slice:2;">
            <gen-navigation-bar-item
                [item]="navigationItem"
                (onNavigationClick)="onNavigationClick($event)"
                [isFirst]=false
                [selected]="isItemActive(navigationItem)"
                [isDropdown]=true>
            </gen-navigation-bar-item>
          </ng-container>
        </div>
      </section>
    </ng-container>

    <ng-container *ngIf="chosenBrand$ | async as chosenBrand; else defaultBrand">
      <gen-brand-preview [chosenBrand]="chosenBrand"></gen-brand-preview>
    </ng-container>

    <ng-template #defaultBrand>
      <gen-brand-preview [chosenBrand]="defaultBrand$ | async"></gen-brand-preview>
    </ng-template>
  </ng-container>
</ng-container>
